/**
 * Standup Service
 * AIDLC Administrative Backend
 *
 * API calls for daily standup entry CRUD and auto-generation.
 */

import apiClient from './api';
import type { StandupEntry } from '../types/projects';

const STANDUPS_PATH = '/standups';

/**
 * Fetch standup entries for a project on a given date
 */
export async function fetchStandups(projectId: string, date: string): Promise<StandupEntry[]> {
  const response = await apiClient.get<StandupEntry[]>(
    `${STANDUPS_PATH}?projectId=${encodeURIComponent(projectId)}&date=${encodeURIComponent(date)}`
  );
  return response.data;
}

/**
 * Create or update a standup entry
 */
export async function createStandup(data: {
  projectId: string;
  agentId: string;
  date: string;
  yesterday: string;
  today: string;
  blockers: string;
}): Promise<StandupEntry> {
  const response = await apiClient.post<StandupEntry>(STANDUPS_PATH, data);
  return response.data;
}

/**
 * Auto-generate standup entries from agent activity data
 */
export async function generateStandups(projectId: string): Promise<StandupEntry[]> {
  const response = await apiClient.post<StandupEntry[]>(`${STANDUPS_PATH}/generate`, { projectId });
  return response.data;
}
